import { render, staticRenderFns } from "./attachments_warning.vue?vue&type=template&id=298b22d6"
import script from "./attachments_warning.vue?vue&type=script&lang=js"
export * from "./attachments_warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports